import { EvaluationCycle } from '../../../services/peoplePerformanceApi';

const CYCLE_STATUS_LABELS: Record<string, string> = {
  Draft: 'Rascunho',
  Open: 'Aberto',
  Closed: 'Encerrado',
};

type EvaluationCycleSummarySectionProps = {
  cycle: EvaluationCycle | null;
  loading: boolean;
  canWrite: boolean;
  deletingCycle: boolean;
  calendarCount?: number;
  formCount?: number;
  onOpen: () => void;
  onClose: () => void;
  onDelete: () => void;
};

export function EvaluationCycleSummarySection({
  cycle,
  loading,
  canWrite,
  deletingCycle,
  calendarCount,
  formCount,
  onOpen,
  onClose,
  onDelete,
}: EvaluationCycleSummarySectionProps) {
  if (loading) {
    return (
      <section className="mb-4 rounded-xl border border-secondary-200 bg-white p-4">
        <p className="text-sm text-secondary-500">Carregando status do ciclo...</p>
      </section>
    );
  }

  if (!cycle) {
    return (
      <section className="mb-4 rounded-xl border border-secondary-200 bg-white p-4">
        <p className="text-sm text-secondary-500">Ciclo não encontrado.</p>
      </section>
    );
  }

  return (
    <section className="mb-4 rounded-xl border border-secondary-200 bg-white p-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <p className="text-sm text-secondary-500">Status</p>
          <p className="text-lg font-semibold text-secondary-900">
            {CYCLE_STATUS_LABELS[cycle.status] ?? cycle.status}
          </p>
        </div>
        <div className="flex flex-wrap gap-2">
          {canWrite ? (
            <button
              type="button"
              className="erp-btn-danger text-sm"
              disabled={deletingCycle}
              onClick={onDelete}
            >
              {deletingCycle ? 'Excluindo...' : 'Excluir ciclo'}
            </button>
          ) : null}
          {cycle.status === 'Draft' ? (
            <button type="button" className="erp-btn-primary" onClick={onOpen}>
              Abrir ciclo
            </button>
          ) : null}
          {cycle.status === 'Open' ? (
            <button type="button" className="erp-btn-secondary" onClick={onClose}>
              Encerrar ciclo
            </button>
          ) : null}
        </div>
      </div>
      <div className="mt-4 grid gap-3 md:grid-cols-2 lg:grid-cols-3">
        <span>Autoavaliação: {cycle.enableSelfEvaluation ? 'sim' : 'não'}</span>
        <span>Gestor (90°): {cycle.enableManagerEvaluation ? 'sim' : 'não'}</span>
        <span>Pares (180°): {cycle.enablePeersEvaluation ? 'sim' : 'não'}</span>
        <span>Colaborador→gestor: {cycle.enableUpwardEvaluation ? 'sim' : 'não'}</span>
        <span>Feedback: {cycle.enableCycleFeedback ? 'sim' : 'não'}</span>
        <span>
          Período:{' '}
          {new Date(cycle.periodStartUtc).toLocaleDateString('pt-BR')}
          {' — '}
          {new Date(cycle.periodEndUtc).toLocaleDateString('pt-BR')}
        </span>
        {typeof calendarCount === 'number' ? <span>Calendários: {calendarCount}</span> : null}
        {typeof formCount === 'number' ? <span>Formulários: {formCount}</span> : null}
      </div>
    </section>
  );
}
